export default __webpack_public_path__ + "static/media/new-ideas.b0d2523d.jpg";